<template>
    <div>
        <legend>Запросы на переделку</legend>
        <dx-data-grid
                :show-borders="true"
                :data-source="dataSource"
                :remote-operations="true"
                row-template="dataRowTemplate"
                :ref="dataGridRefKey"
        >

            <!--            "": "ewt",-->
            <!--            "": 1,-->
            <!--            "": "2019-09-20 00:00:00",-->
            <!--            "": 1234567,-->
            <!--            "": "shsert",-->
            <!--            "": "Север3",-->
            <!--            "": "Летчика Бабушкина, 38, корп. 2, Gerf",-->
            <!--            "": "БР КИарк 50х70",-->
            <!--            "": "БН",-->
            <!--            "Summary": 39782-->
            <dx-paging :page-size="5"/>
            <dx-column
                    data-field="ReadyDate"
                    data-type="date"
                    caption="Дата принятия"
            />
            <dx-column
                    data-field="SferaNumber"
                    data-type="string"
                    caption="Номер заказ"
            />
            <dx-column
                    data-field="LocalNumber"
                    caption="Внутренний номер"
            />
            <dx-column
                    data-field="TourName"
                    caption="Объезд"
            />
            <dx-column
                    data-field="Reception"
                    caption="Партнер"
            />
            <dx-column
                    data-field="Sku"
                    caption="Артикул"
            />
            <dx-column
                    data-field="PaymentType"
                    caption="Тип оплаты"
            />
            <dx-column
                    data-field="Summary"
                    data-type="string"
                    caption="Сумма"
            />
            <dx-column
                    caption="Опции"
            />

            <tbody
                    slot="dataRowTemplate"
                    slot-scope="{ data: rowInfo }"
                    class="dx-row"
            >
            <tr class="main-row">
                <td>{{ rowInfo.data.ReceivedDate | formatDate("DD-MM-YYYY HH:mm") }}</td>
                <td>
                    <router-link :to="{ name: 'order-edit', params:{orderId:rowInfo.data.PartnerOrderId}}">{{ rowInfo.data.SferaNumber }}
                    </router-link>
                </td>
                <td>{{ rowInfo.data.LocalNumber }}</td>
                <td>{{ rowInfo.data.TourName }}</td>
                <td>{{ rowInfo.data.Reception }}</td>
                <td>{{ rowInfo.data.Sku }}</td>
                <td>{{ rowInfo.data.PaymentType }}</td>
                <td>{{ rowInfo.data.Summary }}</td>
                <td><a href="#" @click.prevent="remove(rowInfo)">Удалить</a></td>
            </tr>
            <tr class="notes-row">
                <td colspan="6">
                    <div>Комменатрий: {{ rowInfo.data.Message }}</div>
                </td>
            </tr>
            </tbody>
        </dx-data-grid>
    </div>
</template>
<script>
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { DxColumn, DxDataGrid, DxPaging } from 'devextreme-vue/data-grid';
import moment from 'moment';

const url = `${process.env.VUE_APP_API_HOST}admin/recast-request`;


export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
  },
  data() {
    return {
      dataGridRefKey: 'dataGrid',
    };
  },
  filters: {
    formatDate(value, format) {
      return moment(value)
        .format(format);
    },
  },
  computed: {
    dataSource() {
      const token = this.$auth.token();
      return createStore({
        key: 'Id',
        loadUrl: `${url}`,
        // insertUrl: `${url}/${this.$route.params.id}/insert`,
        // updateUrl: `${url}/update`,
        deleteUrl: `${url}/delete`,
        onBeforeSend(operation, ajaxOptions) {
          ajaxOptions.headers = {
            Authorization: `Bearer ${token}`,
          };
        },
      });
    },
    dataGrid() {
      return this.$refs[this.dataGridRefKey].instance;
    },
  },
  methods: {
    async remove(rowInfo) {
      this.dataGrid.removeRow(rowInfo.dataIndex);
    },
  },
};
</script>
<style lang="scss">
/*tbody.dx-row {*/
/*    tr {*/
/*        !*border: 1px solid #ddd;*!*/
/*        border-bottom: 1px solid #ddd;*/
/*        td {*/
/*        }*/
/*    }*/
/*}*/
</style>
